module.exports = __webpack_public_path__ + "media/images/mobile/Mask Group 10-2166a90ce75b35449c4d54be0498c3e2.png";